import React from 'react';
import TextToSpeech from './components/TextToSpeech';
import './App.css';

function App() {
    return (
        <div className="App">
            <TextToSpeech />
        </div>
    );
}

export default App;
